var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags-wrapper"},_vm._l((_vm.tags),function(tag,index){return _c('Tag',{key:index,attrs:{"tag":tag,"tagTemplate":_vm.tagTemplate[tag.tagType]}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }